<template functional>
  <div class="progress-bar-preview__wrapper">
    <div class="progress-bar-preview">
      <div
        class="progress-bar-preview__bar"
        :class="
          props.size === 'small'
            ? 'progress-bar-preview__bar__small'
            : 'progress-bar-preview__bar__medium'
        "
        :style="`width: ${props.value}%`"
      ></div>
    </div>
    <div v-if="props.displayValue" class="progress-bar-preview__value">
      {{ `${props.value}%` }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewProgressBar',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: () => {
        return 'medium'
      },
    },
    displayValue: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
  },
}
</script>

<style lang="scss">
.progress-bar-preview {
  &__wrapper {
    display: flex;
    align-items: center;
  }
  width: 100%;
  text-align: center;
  border-radius: 10px;
  background-color: var(--white-25);
  @include tablet {
  }
  &__bar {
    background-color: var(--white);
    border-radius: 10px;
    position: relative;
    &__medium {
      height: 8px;
    }
    &__small {
      height: 5px;
    }
  }
  &__value {
    padding-left: 10px;
  }
}
</style>
